import { sniffCommentFileKind } from "../comments/files";

/**
 * What a feedback screenshot may be, in one place for the API that enforces it
 * and the dialog that tells the reporter before they hit it (#319, #498).
 *
 * One rule for both ways a screenshot arrives — the automatic capture and an
 * image the reporter attaches themselves. The dialog flattens either one
 * through the same canvas, so what it sends is always a PNG or, when the PNG is
 * too big, a JPEG; the API holds the line for anything that did not come from
 * the dialog.
 */

/** Per screenshot, as stored. */
export const MAX_FEEDBACK_SCREENSHOT_BYTES = 2 * 1024 * 1024;

export type FeedbackScreenshotType = "image/png" | "image/jpeg";

/**
 * What a file picker's `accept` should offer. GIF and WebP are not here: the
 * automatic capture is never either, and the stored type is what the API later
 * serves back, so the list is the shortest one that covers real screenshots.
 * SVG is deliberately absent too — it is an image that can carry script.
 */
export const FEEDBACK_SCREENSHOT_ACCEPT = "image/png,image/jpeg";

/**
 * What a screenshot is, from its own first bytes — never from the type the
 * browser sent. `null` for anything that is not a PNG or a JPEG. The type a
 * screenshot is stored under, and later served with, is this one.
 */
export function sniffFeedbackScreenshotType(
  bytes: Uint8Array,
): FeedbackScreenshotType | null {
  const kind = sniffCommentFileKind(bytes);
  return kind === "image/png" || kind === "image/jpeg" ? kind : null;
}
